export default "/_next/static/images/service-maxbone-desktop@2x-0bbbaef35d8b19ec46c56341730cd9b2.jpg";